<template>

	
    <div 
    	v-show="'data-view' == currentComponent"
    	:class="`vw-component vw-component--data-view active`" 
    	id="vw-component--data-view"
    	>
	    <div class="dt-wrap mb-4">
    
	    	<DataviewComponent 
	    		v-if="templateData.component_data_view" 
				:templateData="templateData.component_data_view" 
				@refresh="refreshDataview"
	    	/>
	    </div>
    </div>



    <div
    	
    	:class="`vw-component vw-component--calendar ${ 'calendar' == currentComponent ? 'active' : '' }`" 
    	id="vw-component--calendar"
    	>
    <!-- {% if component_calendar %}
    {% include 'components/calendars/_calendar-component-vue.twig' with { calendar_json: component_calendar, label: calendar_post.label ?: calendar_post.title, calendar_post: calendar_post, 'vw': true } %}
    {% endif %} -->
    	<div class="calendar-component-vue bryter-calendar ">
		    <CalendarComponent 
			    v-if="templateData.component_calendar"
			    :templateData="templateData.component_calendar"
		    />
		</div>
    </div>

    <div 
    	v-show="'board' == currentComponent"
    	:class="`vw-component vw-component--board active`" 
    	id="vw-component--board">
	    <!-- {% if component_board %}
	    {% include 'components/boards/_board-component-vue.twig' with {  board : component_board, 'vw': true } %}
	    {% endif %} -->
	    <div class="board-container-vue">
		    <BoardComponent
		    	v-if="templateData.component_board"
		        :options="{ board: templateData.component_board }"
	    	/>
	    </div>
    </div>
	
</template>


<script>

import DataviewComponent from '@vueapp/components/DataviewComponent.vue'
import CalendarComponent from '@vueapp/components/CalendarComponent.vue'
import BoardComponent from '@vueapp/components/BoardComponent.vue'

export default {
	name: 'ViewWrapperComponent',

	props: {
		templateData: {
			type: Object,
			required: true,
			default: {}
		}
	},

	emits: ['refresh'],

	components: {
		DataviewComponent,
		CalendarComponent,
		BoardComponent
	},

	computed: {
		feTheme() {
            return window.fe_theme 
        },
	},

	data() {
		return {
			currentComponent: 'data-view'
		}
	},

	methods: {
		refreshDataview() {
			this.$emit('refresh')
		}
	},

	created() {
		this.emitter.on('wrapper-toggle-update', e => {
			const target = e.target
			if ( target ) {
				this.currentComponent = target

				window.dispatchEvent(new Event('resize'))
			}
		})
	}


}
</script>